export default __webpack_public_path__ + "static/media/GIC_Swipe_Copy_Email.2b22d08a.pdf";